export enum FileInfoStatus {
  APTO = 'APT',
  PENDIENTE_REVISION = 'PRV',
  NON_APTO = 'NAP',
  EN_REQUERIMENTO = 'ERQ',
  NON_PROCEDE = 'NPR'
}
